import React from 'react';
import { Box, Typography, LinearProgress, Grid } from '@mui/material';
import './styles.css';

const DashboardCard = ({ 
  items, 
  title, 
  progress, 
  totalValue, 
  color = '#4caf50' 
}) => {
  return (
    <Box className="dashboard-card">
      <Grid container spacing={1.5}>
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <Grid item xs={8}>
              <Typography
                className="metric-label"
                variant="body2"
                color="text.secondary"
              >
                {item.label}
              </Typography>
            </Grid>
            <Grid item xs={4} textAlign="right">
              <Typography
                className="metric-value"
                variant="body2"
                fontWeight="medium"
              >
                {item.value}
              </Typography>
            </Grid>
           
              <Grid item xs={12}>
                <div className="divider" />
              </Grid>
         
          </React.Fragment>
        ))}
      </Grid>

      {progress !== undefined && (
        <Box mt={2.5} display="flex" justifyContent="space-between" alignItems="center">
          <div className="progress-bar-container">
            <LinearProgress
              variant="determinate"
              value={progress}
              sx={{
                height: 6,
                borderRadius: 3,
                backgroundColor: "#e0e0e0",
                "& .MuiLinearProgress-bar": {
                  backgroundColor: color,
                },
              }}
            />
          </div>
          <Box display="flex" justifyContent="space-between"width="58%" alignItems="center">
            <Typography className="metric-percentage">{progress}%</Typography>
            <Typography className="metric-total">{totalValue}</Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default DashboardCard; 